module.exports = __webpack_public_path__ + "img/发呆.e9e45532.png";